// Copyright (c) 2016 Deere & Company

import DealerDisplayFormat, {getDefaultState as getDealerDisplayFormatDefaultState} from './dealer-display-format';
import DealerSettingsAccounts, {getDefaultState as getDealerAccountsDefaultState} from './dealer-settings-accounts';
import t from 'tcomb';

const DealerSettings = t.struct({
    accounts: DealerSettingsAccounts,
    displayFormat: DealerDisplayFormat
}, {
    name: 'DealerSettings',
    strict: true
});

export const getDefaultState = () => new DealerSettings({
    accounts: getDealerAccountsDefaultState(),
    displayFormat: getDealerDisplayFormatDefaultState()

});

export default DealerSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-settings.js